const ChartJSPluginNoDataBackground = {
    id: 'noDataBackground',
    beforeInit (chart, options) {
        if (!options || !options.display) return
        chart.noDataImage = new Image()
        chart.noDataImage.src = options.imageSrc || require('@/assets/images/pages/calendar-illustration.png')
    },
    beforeDraw: (chart, args, options) => {
        if (!options || !options.display) return
        const { ctx, data, canvas, chartArea: { left, top } } = chart
        if (data.datasets.length === 0 || data.datasets.every(dataset => dataset.data.length === 0)) {
            if (chart.noDataImage && chart.noDataImage.complete) {
                const image = chart.noDataImage
                // bg
                const imgWidth = image.width || 160
                const imgHeight = image.height || 140
                const x = parseInt(canvas.style.width) / 2 - (imgWidth / 2) + (left / 2)
                let y = parseInt(canvas.style.height) / 2 - (imgHeight / 2) - (top / 4)
                const chartType = data.datasets[0] && data.datasets[0].type
                y -= chartType === 'bar' ? 12 : (chartType === 'line' ? 20 : 0)
                ctx.save()
                ctx.globalAlpha = options.imageOpacity || 1.0
                ctx.drawImage(image, x, y)

                // text
                ctx.font = options.font || '14px'
                ctx.fillStyle = options.fillStyle || '#979797'
                ctx.textAlign = options.textAlign || 'center'
                ctx.textBaseline = options.textBaseline || 'middle'
                ctx.fillText(options.text || '', x + (imgWidth / 2), y + imgHeight + 4)
                ctx.restore()
            }
        }
    }
}

export default ChartJSPluginNoDataBackground
